module.exports = __webpack_public_path__ + "static/media/card-6.e7838ffd.jpf";